import { getUserId } from '../../../auth';
import { safeAccess } from '../../../utils';

export const getTuitionData = (state) =>
  safeAccess(state, `tuition.cache[${getUserId(state)}]`, {});

export const getTuitionInstitutionData = (state) => safeAccess(state, 'tuitionInstitution.cache');
